<template>
  <footer class=" text-light text-center py-2">
    &copy; 2024 Pham Quang Phuc
  </footer>
</template>

<script>
export default {
  name: '',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
